export default __webpack_public_path__ + "static/media/faq-header-image-mobile.37c5cbe7.png";